// ImpressionRate.jsx
import React from "react";
import { ArrowUp, Info } from "lucide-react";

const ImpressionRate = () => {
  return (
    <div className="p-2 md:p-4">
      <h3 className="text-lg font-bold uppercase mb-2 pb-2 border-b border-black-40">
        Earned Value By Impression
      </h3>
      <p className="text-6xl font-bold text-black-600 flex items-center gap-2">
        <span>100,00 € </span>
        <button className="p-2 rounded-lg group relative">
          <Info className="w-6 h-6 text-black-700 relative" />
          <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap">
            Estimated € impact: clicks × cost-per-click (in €)
            <div className="absolute top-1/2 left-full -translate-y-1/2 border-4 border-transparent border-l-gray-800"></div>
          </div>
        </button>
      </p>
      <div className="flex items-center text-xs gap-1 text-primary-700 mt-4">
        <ArrowUp size={16} /> 5%
        <span className="text-lg font-bold text-black-400">
          vs. previous period
        </span>
      </div>
    </div>
  );
};

export default ImpressionRate;
